/* istanbul ignore file */

import type { SVGProps } from 'react';
import { useTheme } from 'styled-components';

import type theme from '@shared/theme';

type Props = SVGProps<SVGSVGElement> & {
    fillColor?: keyof typeof theme.colors;
};

export default function OrganisationIcon({ fillColor, ...props }: Props) {
    const theme = useTheme();

    return (
        <svg
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            {...props}
            role="img"
        >
            <path
                fill={fillColor ? theme.colors[fillColor] : '#fff'}
                d="M2.365 20.153V5.69c0-.422.148-.78.443-1.076a1.465 1.465 0 0 1 1.076-.443h6.462c.422 0 .78.148 1.076.443.295.296.443.654.443 1.076v2.48h8.25c.422 0 .78.149 1.076.444.296.296.443.654.443 1.076v10.462c0 .421-.148.78-.443 1.076a1.465 1.465 0 0 1-1.076.443H3.885c-.422 0-.781-.148-1.077-.443a1.465 1.465 0 0 1-.443-1.076Zm1.5.019h2.5v-2.5h-2.5v2.5Zm0-4h2.5v-2.5h-2.5v2.5Zm0-4h2.5v-2.5h-2.5v2.5Zm0-4h2.5v-2.5h-2.5v2.5Zm4 12h2.5v-2.5h-2.5v2.5Zm0-4h2.5v-2.5h-2.5v2.5Zm0-4h2.5v-2.5h-2.5v2.5Zm0-4h2.5v-2.5h-2.5v2.5Zm4 12h8.27v-10.5h-8.27v2.5h2.192v1.5h-2.192v2.5h2.192v1.5h-2.192v2.5Zm4.385-6.5v-1.5h1.5v1.5h-1.5Zm0 4v-1.5h1.5v1.5h-1.5Z"
            />
        </svg>
    );
}
